<template>
  <div>
    <el-row>
      <el-col :span="9">
        <h3>Formulario de Creación de Fórmula</h3>
        <el-form label-position="top">
          <el-form-item label="Nombre del Fórmula">
            <el-input
              placeholder="Ej: TECNOLOGÍA - Disponibilidad Infraestructura de Red"
              v-model="formulaModel.Name"
              style="width: 70%"
            ></el-input>
          </el-form-item>
          <el-row style="width: 70%">
            <el-col :span="12">
              <el-form-item label="Tipo de Fórmula">
                <el-select
                  v-model="formulaModel.Type"
                  size="medium"
                  @change="handleFormulaTypeChange"
                >
                  <el-option
                    v-for="type in formulaTypes"
                    :key="type.Id"
                    :label="type.Description"
                    :value="type.Id"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="type.Meaning"
                      placement="right"
                    >
                      <span>{{ type.Description }}</span>
                    </el-tooltip>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="float: right">
              <el-form-item label="Seleccione la Gerencia">
                <el-select
                  v-model="selectedDirection"
                  filterable
                  clearable
                  placeholder="Direccion"
                  width="200"
                  @change="handleDirectionChange"
                >
                  <el-option
                    v-for="(direction, index) in directions"
                    :key="index"
                    :label="direction.label"
                    :value="direction"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="Descripción de la Fórmula">
            <el-input
              type="textarea"
              placeholder="Realiza el cálculo entre cantidad de horas activas y cantidad de horas inactivas"
              v-model="formulaModel.Description"
              autosize
              style="width: 70%"
            ></el-input>
          </el-form-item>
          <el-form-item label="Contenido del Query:">
            <el-input
              type="textarea"
              :rows="12"
              placeholder="INSERT INTO KpiMasterChilds ... "
              v-model="formulaModel.Query"
              style="width: 90%"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              v-loading="savingLoading"
              type="primary"
              style="float: right; margin-right: 70px"
              @click="saveFormula"
              >Guardar</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span="15">
        <h3>Listado de Fórmulas</h3>
        <el-tabs type="border-card" @tab-click="handleTabClick">
          <el-tab-pane label="TODAS">
            <rabbey-table-3
              :loading="kpiFormulaLoading"
              :data="kpiFormulaList"
              :columns="kpiFormulaColumns"
            />
          </el-tab-pane>
          <el-tab-pane label="COMERCIAL" value>
            <rabbey-table-3
              :loading="kpiFormulaLoading"
              :data="kpiFormulaList"
              :columns="kpiFormulaColumns"
            />
          </el-tab-pane>
          <el-tab-pane label="TECNOLOGIA">
            <rabbey-table-3
              :loading="kpiFormulaLoading"
              :data="kpiFormulaList"
              :columns="kpiFormulaColumns"
            />
          </el-tab-pane>
          <el-tab-pane label="FINANCIERA">
            <rabbey-table-3
              :loading="kpiFormulaLoading"
              :data="kpiFormulaList"
              :columns="kpiFormulaColumns"
            />
          </el-tab-pane>
          <el-tab-pane label="CAPITAL HUMANO">
            <rabbey-table-3
              :loading="kpiFormulaLoading"
              :data="kpiFormulaList"
              :columns="kpiFormulaColumns"
            />
          </el-tab-pane>
          <el-tab-pane label="ADMINISTRATIVA">
            <rabbey-table-3
              :loading="kpiFormulaLoading"
              :data="kpiFormulaList"
              :columns="kpiFormulaColumns"
            />
          </el-tab-pane>
          <el-tab-pane label="OPERACIONES Y PROYECTOS">
            <rabbey-table-3
              :loading="kpiFormulaLoading"
              :data="kpiFormulaList"
              :columns="kpiFormulaColumns"
            />
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>

    <!-- DIABLOGS -->
    <el-dialog
      title="Detalle de la Fórmula"
      :visible.sync="viewFormulaDialog"
      width="50%"
      :before-close="handleFormulaDialogClose"
    >
      <el-button
        size="mini"
        type="primary"
        style="float: right; margin-bottom: 10px"
        @click="setEditable"
        ><i class="el-icon-edit"></i>
      </el-button>

      <el-form label-position="top">
        <el-form-item label="Nombre">
          <el-input
            type="textarea"
            autosize
            :disabled="isDisable"
            v-model="formulaName"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Tipo Seleccionado">
              <el-select
                :disabled="isDisable"
                v-model="formulaTypeDialog"
                size="medium"
                @change="handleFormulaTypeEdit"
              >
                <el-option
                  v-for="type in formulaTypes"
                  :key="type.Id"
                  :label="type.Description"
                  :value="type.Id"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="type.Meaning"
                    placement="right"
                  >
                    <span>{{ type.Description }}</span>
                  </el-tooltip>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Gerencia Seleccionada">
              <el-select
                v-model="formulaDirection"
                :disabled="isDisable"
                filterable
                clearable
                placeholder="Direccion"
                width="200"
                @change="handleDirectionEdit"
              >
                <el-option
                  v-for="(direction, index) in directions"
                  :key="index"
                  :label="direction.label"
                  :value="direction"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Descripción">
          <el-input
            type="textarea"
            autosize
            :disabled="isDisable"
            v-model="formulaDescription"
          ></el-input>
        </el-form-item>
        <el-form-item label="Query">
          <el-input
            type="textarea"
            :rows="15"
            :disabled="isDisable"
            v-model="formulaQuery"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="!isDisable"
          type="primary"
          size="mini"
          @click="updateFormula"
        >
          Guardar
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="ADVERTENCIA"
      :visible.sync="deleteFormulaDialog"
      width="20%"
      :before-close="handleDeleteClose"
      center
    >
      <h3 style="margin-left: 30px">
        ¿Seguro que desea eliminar esta fórmula?
      </h3>
      <h4 style="margin: 0 15px">
        En caso de que algún KPI esté utilizando esta fórmula este volverá a ser
        manual
      </h4>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteFormulaDialog = false">Cancelar</el-button>
        <el-button type="danger" @click="deleteFormula">Si, Eliminar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { formatArrayToElSelect } from "@/utils";
import ButtonInLineFormatter from "@/components/functionals/ButtonInLineFormatter.vue";
export default {
  name: "KpiFormulas",
  data() {
    return {
      formulaModel: {
        Name: "",
        Description: "",
        Query: "",
        CreatedBy: 0,
        Type: "",
        DirectionId: ""
      },
      directions: [],
      selectedDirection: "",

      savingLoading: false,
      formulaTypes: [
        //Usan el mismo ID que los KPI, 1 Manual, 2 Semi-Automático y 3 Full-Automático.
        {
          Id: 2,
          Description: "SEMI-AUTOMÁTICO",
          Meaning:
            "Solo el Valor será calculado automáticamente por esta fórmula."
        },
        {
          Id: 3,
          Description: "FULL-AUTOMÁTICO",
          Meaning:
            "Tanto la Meta como el Valor serán calculados por esta fórmula."
        }
      ],

      //FORMULA DIALOG VARIABLES
      kpiFormulaLoading: false,
      selectedFormula: null,
      kpiFormulaList: [],
      kpiFormulaColumns: [
        {
          prop: "Id",
          label: "ID",
          width: 50
        },
        {
          prop: "Name",
          label: "Fórmula"
        },
        {
          prop: "Description",
          label: "Descripción"
        },
        {
          prop: "Id",
          label: "",
          width: 65,
          formatter: ButtonInLineFormatter,
          attrs: {
            icon: "el-icon-view",
            buttonType: "primary",
            onClick: this.viewFormula
          }
        },
        {
          prop: "Id",
          label: "",
          width: 65,
          formatter: ButtonInLineFormatter,
          attrs: {
            icon: "el-icon-delete",
            buttonType: "danger",
            onClick: this.confirmFormulaDeletion
          }
        }
      ],

      //DIALOGS
      viewFormulaDialog: false,
      isDisable: true,
      formulaId: 0,
      formulaQuery: "",
      formulaName: "",
      formulaDescription: "",
      formulaTypeDialog: "",
      formulaDirection: "",

      // >> ELIMINAR FORMULA
      deleteFormulaDialog: false,
      formulaToDelete: 0,

      // Formula Tabs
      currentDirectionTab: ""
    };
  },
  created() {
    this.getAllFormulas();
    this.getDirections();
    this.formulaModel.CreatedBy = this.currentUser.UserID;
  },
  methods: {
    handleFormulaTypeChange(formulaType) {
      this.formulaModel.Type = formulaType;
    },
    handleFormulaTypeEdit(formulaType) {
      this.formulaTypeDialog = formulaType;
    },
    saveFormula() {
      this.savingLoading = true;
      this.$http
        .post("/api/kpis/AddNewFormula", this.formulaModel)
        .then(() => {
          this.savingLoading = false;
          this.$message({
            type: "success",
            message: "Fórmula agregada exitosamente"
          });
          this.getAllFormulas();
          this.clearForm();
        })
        .catch(() => {
          this.savingLoading = false;
          this.$message({
            type: "error",
            message: "Error al agregar fórmula"
          });
        });
    },
    clearForm() {
      this.formulaModel.Name = "";
      this.formulaModel.Description = "";
      this.formulaModel.Query = "";
      this.formulaModel.Type = "";
      this.formulaModel.DirectionId = "";
      this.selectedDirection = "";
    },
    formatArrayToElSelect,
    getDirections() {
      this.$http
        .get("/api/Directions/DirectionsByCompany", {
          params: {
            company: this.currentCompany
          }
        })
        .then((response) => {
          this.directions = this.formatArrayToElSelect(response.data);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleDirectionChange(selectedDirection) {
      this.formulaModel.DirectionId = selectedDirection.Id;
    },
    handleDirectionEdit(selectedDirection) {
      this.formulaDirection = selectedDirection;
    },

    //DIALOG
    viewFormula(row) {
      this.viewFormulaDialog = true;
      this.formulaId = row.Id;
      this.formulaQuery = row.Query;
      this.formulaName = row.Name;
      this.formulaTypeDialog = row.Type;
      this.formulaDescription = row.Description;
      this.formulaDirection = this.directions.find(
        (dir) => dir.Id == row.DirectionId
      );
    },
    handleFormulaDialogClose() {
      this.viewFormulaDialog = false;
      this.isDisable = true;
    },

    confirmFormulaDeletion(row) {
      this.deleteFormulaDialog = true;
      this.formulaToDelete = row.Id;
    },
    handleDeleteClose() {
      this.deleteFormulaDialog = false;
    },

    getAllFormulas(kpiType = 0, kpiDirection = 0) {
      this.kpiFormulaLoading = true;
      this.$http
        .get(
          `/api/kpis/GetAllFormulas?kpiType=${kpiType}&kpiDirection=${kpiDirection}`
        )
        .then((response) => {
          this.kpiFormulaList = response.data;
          this.kpiFormulaLoading = false;
        });
    },
    setEditable() {
      this.isDisable = false;
    },

    updateFormula() {
      let editFormulaForm = {
        Id: this.formulaId,
        Query: this.formulaQuery,
        Name: this.formulaName,
        Description: this.formulaDescription,
        UpdatedBy: this.currentUser.UserID,
        Type: this.formulaTypeDialog,
        DirectionId: this.formulaDirection.Id
      };
      this.$http.post("/api/kpis/EditFormula", editFormulaForm).then(() => {
        this.savingLoading = false;
        this.$message({
          type: "success",
          message: "Fórmula editada exitosamente"
        });
        this.viewFormulaDialog = false;
        this.isDisable = true;
        if (this.currentDirectionTab.Id) {
          this.getAllFormulas(0, this.currentDirectionTab.Id);
        } else {
          this.getAllFormulas();
        }
      });
    },

    deleteFormula() {
      this.$http
        .delete(`/api/kpis/DeleteFormula?formulaId=${this.formulaToDelete}`)
        .then(() => {
          this.$message({
            type: "success",
            message: "Formula eliminada con éxito"
          });
          this.deleteFormulaDialog = false;
          this.formulaToDelete = 0;
          this.getAllFormulas();
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "Error al intentar borrar formula"
          });
        });
    },
    handleTabClick(tab) {
      this.currentDirectionTab = this.directions.filter(
        (dir) => dir.Name == tab.label
      )[0];
      //console.log();
      if (this.currentDirectionTab) {
        this.getAllFormulas(0, this.currentDirectionTab.Id);
      } else {
        this.getAllFormulas();
      }
    }
  }
};
</script>

<style></style>
